/* Black Horse Supplements — shared custom scripts (v1.5, v2.7).
   Loaded once (defer) from snippets/bhs-head-meta.liquid.
   Ported from the SPS store: newsletter message + sign-up link, richer predictive search.
   v2.7: the policy pop-up (part 1) moved to assets/bhs-policy-modal.js (loaded from sections/bhs-site-scripts.liquid). */

/* 0) Hide empty paragraphs in policy text (they create large gaps) */
window.bhsHideEmpty = function (root) {
  if (!root) return;
  root.querySelectorAll('p, div').forEach(function (el) {
    if (el.querySelector('img, iframe, table, video, svg')) return;
    if (!el.textContent.replace(/\u00a0/g, '').trim()) el.classList.add('bhs-empty');
  });
};
(function () {
  function run() { window.bhsHideEmpty(document.querySelector('.shopify-policy__body')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* 2) Newsletter: error message when the email is empty/invalid, and a
      "sign up now" link in the section text that jumps to the email field */
(function () {
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg><span></span>';

  function signupLinks() {
    document.querySelectorAll('.newsletter').forEach(function (root) {
      var sub = root.querySelector('.newsletter__subheading');
      var input = root.querySelector('input[type="email"]');
      if (!sub || !input || sub.querySelector('a.bhs-nl-link')) return;
      var walker = document.createTreeWalker(sub, NodeFilter.SHOW_TEXT), node;
      while ((node = walker.nextNode())) {
        var m = /sign up now/i.exec(node.nodeValue);
        if (!m) continue;
        var after = node.splitText(m.index);
        after.splitText(m[0].length);
        var a = document.createElement('a');
        a.href = '#' + (input.id || '');
        a.className = 'bhs-nl-link';
        a.textContent = after.nodeValue;
        after.parentNode.replaceChild(a, after);
        break;
      }
      root.addEventListener('click', function (event) {
        var link = event.target.closest ? event.target.closest('a.bhs-nl-link') : null;
        if (!link) return;
        event.preventDefault();
        var field = input.closest('.field');
        input.focus({ preventScroll: true });
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (field) {
          field.classList.remove('bhs-nl-pulse');
          void field.offsetWidth;
          field.classList.add('bhs-nl-pulse');
        }
      });
    });
  }

  function errorMessages() {
    document.querySelectorAll('form').forEach(function (form) {
      var input = form.querySelector('input[type="email"][name="contact[email]"]');
      var tag = form.querySelector('input[name="contact[tags]"]');
      if (!input || !tag || !/newsletter/i.test(tag.value) || form.dataset.bhsNl) return;
      form.dataset.bhsNl = '1';
      form.setAttribute('novalidate', '');

      var field = input.closest('.field');
      var box = document.createElement('small');
      box.className = 'bhs-nl-error';
      box.setAttribute('role', 'alert');
      box.setAttribute('aria-live', 'assertive');
      box.hidden = true;
      box.innerHTML = ICON;
      var anchor = input.closest('.newsletter-form__field-wrapper') || field || input;
      anchor.insertAdjacentElement('afterend', box);
      var text = box.querySelector('span');

      function show(message) {
        text.textContent = message;
        box.hidden = false;
        if (field) field.classList.add('bhs-nl-invalid');
        input.setAttribute('aria-invalid', 'true');
        box.classList.remove('bhs-nl-shake');
        void box.offsetWidth;
        box.classList.add('bhs-nl-shake');
      }
      function clear() {
        box.hidden = true;
        if (field) field.classList.remove('bhs-nl-invalid');
        input.removeAttribute('aria-invalid');
      }
      form.addEventListener('submit', function (event) {
        var value = input.value.trim();
        if (!value) {
          event.preventDefault();
          show('Please enter your email address to subscribe.');
          input.focus();
        } else if (!EMAIL_RE.test(value)) {
          event.preventDefault();
          show('Please enter a valid email address, for example name@example.com');
          input.focus();
        }
      });
      input.addEventListener('input', clear);
    });
  }
  function init() { signupLinks(); errorMessages(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* 3) Predictive search: also match product description, tags and SKU, and hide
      results that do not contain every typed word (SPS header script) */
(function () {
  var of = window.fetch;
  if (of && !window.bhsPsPatch) {
    window.bhsPsPatch = 1;
    window.fetch = function (u, o) {
      if (typeof u === 'string' && u.indexOf('section_id=predictive-search') > -1 && u.indexOf('resources') === -1) {
        u += '&resources[limit]=10&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.sku,vendor,body,tag';
      }
      return of.call(this, u, o);
    };
  }
  var cache = {};
  function desc(h) {
    if (cache[h]) return cache[h];
    cache[h] = fetch('/products/' + h + '.js')
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (j) { return ((j.title || '') + ' ' + (j.description || '') + ' ' + (j.tags || []).join(' ')).replace(/<[^>]*>/g, ' ').toLowerCase(); })
      .catch(function () { return ''; });
    return cache[h];
  }
  function filter() {
    document.querySelectorAll('predictive-search').forEach(function (p) {
      var inp = p.querySelector('input[type=search]');
      if (!inp) return;
      var ws = inp.value.toLowerCase().trim().split(' ').filter(function (x) { return x; });
      if (!ws.length) return;
      var list = p.querySelector('#predictive-search-results-products-list');
      if (!list || list.dataset.bhsQ === inp.value) return;
      list.dataset.bhsQ = inp.value;
      var grp = list.closest('.predictive-search__result-group');
      var lis = [].slice.call(list.querySelectorAll('li'));
      var pend = lis.length, vis = 0;
      function done() { pend--; if (pend <= 0 && grp) grp.style.display = vis ? '' : 'none'; }
      var match = function (s) { return ws.every(function (w) { return s.indexOf(w) > -1; }); };
      lis.forEach(function (li) {
        var h = li.querySelector('.predictive-search__item-heading') || li;
        if (match(h.textContent.toLowerCase())) { li.style.display = ''; vis++; done(); return; }
        li.style.display = 'none';
        var a = li.querySelector('a[href*="/products/"]');
        if (!a) { done(); return; }
        var hd = a.getAttribute('href').split('/products/')[1].split('?')[0];
        desc(hd).then(function (d) { if (match(d)) { li.style.display = ''; vis++; } done(); });
      });
    });
  }
  var t;
  var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(filter, 30); });
  function start() { mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* 4) Snap sticky cart: always sit a fixed 12px above the Inbox "Support" button,
      on mobile and desktop alike (the Support button's height from the bottom
      differs between screens, so the position is measured, not hard-coded).
      Fallback when the Support button is missing: bhs-custom.css (150px). */
(function () {
  var GAP = 12, style = null, last = '';
  function place() {
    var chat = document.querySelector('shopify-chat');
    var act = chat && chat.shadowRoot && chat.shadowRoot.querySelector('[part~="activator"]');
    if (!act) return;
    var r = act.getBoundingClientRect();
    if (!r.height) return;
    var b = Math.round(window.innerHeight - r.top + GAP) + 'px';
    if (b === last) return;
    last = b;
    if (!style) {
      style = document.createElement('style');
      style.id = 'bhs-snap-pos';
      document.head.appendChild(style);
    }
    style.textContent = 'html body .snapCartStickyButton .styles_snapCartStickyButton{bottom:' + b + ' !important}';
  }
  var n = 0, iv = setInterval(function () { place(); if (++n > 30) clearInterval(iv); }, 500);
  window.addEventListener('resize', place);
  window.addEventListener('scroll', place, { passive: true });
  window.addEventListener('orientationchange', function () { setTimeout(place, 300); });
})();